import ApiManager from '../api/crud-manager';
import jsonToView from '../api/json-to-view';

/**
 * Class real time product price module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 */

class RealTimePrice {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimePrice"]'),
      apiManager: new ApiManager(),
      lang: document.documentElement.lang || 'nl',
      ...options
    };
  }

  // fetch product price based on product id
  async getPrice(productId) {
    const { apiManager } = this.config;

    const url = `/api/v2/catalog/product/${productId}/prices`;

    return apiManager.get(url).then(data => data);
  }

  init() {
    const { moduleList, lang } = this.config;
    moduleList().forEach(_module => {
      const parentModule = _module;
      const modules = parentModule.querySelectorAll(`[data-child-module="RealTimePrice__Current"]`);
      if (modules.length > 0) {
        modules.forEach(_childModule => {
          const module = _childModule;
          const { productId, initialized, originalPrice, staffel } = module.dataset;
          const originalModule = parentModule.querySelector(
            `[data-child-module="RealTimePrice__Original-${productId}-${staffel}"]`
          );
          const percentModule = parentModule.querySelector(
            `[data-child-module="RealTimePrice__Percent-${productId}-${staffel}"]`
          );

          if (initialized && initialized.toLowerCase() === 'true') return;

          module.dataset.initialized = 'true';
          const container = module.querySelector('[data-price-container]');

          if (productId && container) {
            if (!container.hasAttribute('data-isloaded')) {
              module.classList.add('is-loading');
              let quantity = 1;
              if (staffel) {
                quantity = parseInt(staffel, 10);
              }
              // Moet deze nog houden
              fetch(
                `/api/v2/catalog/product/${productId}/prices?quantity=${quantity}&currency=EUR`,
                {
                  method: 'GET',
                  headers: {
                    'Accept-Language': lang
                  }
                }
              )
                .then(res => res.json())
                .then(json => {
                  // eslint-disable-next-line no-underscore-dangle
                  const { prices } = json._embedded;

                  const currentPriceHolder = container.querySelector('[data-price-current]');

                  const currentPrice = prices.length ? prices[0].currentPrice : 0;

                  function setPrice(holder, price, text_ = '') {
                    let text = `${text_} <br/>`;
                    const { showCurrency } = holder.dataset;

                    if (window.innerWidth > 1199) text = '';

                    // eslint-disable-next-line no-param-reassign
                    holder.innerHTML = `${text}${showCurrency === 'true' ? '€' : ''}${parseFloat(
                      price
                    )
                      .toFixed(2)
                      .toString()
                      .replace('.', ',')}`;
                  }

                  function setPercent(holder, percent) {
                    // eslint-disable-next-line no-param-reassign
                    holder.innerHTML = `${
                      window.innerWidth > 1199 ? '' : 'Korting <br/>'
                    }${parseFloat(percent)
                      .toFixed(2)
                      .toString()
                      .replace(/\.00$/, '')
                      .replace('.', ',')}%`;
                  }

                  function getPercent(_original, _current) {
                    const original = parseFloat(_original).toFixed(2);
                    const current = parseFloat(_current).toFixed(2);
                    return Math.round(100 - (current * 100) / original);
                  }

                  if (currentPriceHolder) {
                    setPrice(currentPriceHolder, currentPrice, 'Netto');
                  }

                  if (originalPrice && originalModule && percentModule) {
                    const originalPriceHolder = originalModule.querySelector(
                      '[data-price-original]'
                    );
                    if (originalPriceHolder) {
                      setPrice(originalPriceHolder, originalPrice, 'Bruto');
                    }

                    const percentHolder = percentModule.querySelector('[data-price-percent]');
                    if (percentHolder) {
                      setPercent(percentHolder, getPercent(originalPrice, currentPrice));
                    }
                  }

                  container.classList.remove('hidden');
                  module.classList.remove('is-loading');
                })
                .catch(() => {
                  container.innerHTML = module.dataset.errorMessage || 'Price not available';
                  container.classList.remove('hidden');
                  module.classList.remove('is-loading');
                  module.classList.add('is-error');
                });
            }

            // prevent double fetch calls
            if (!container.hasAttribute('data-isloaded')) {
              container.dataset.isloaded = true;
            }
          } else {
            container.innerHTML = module.dataset.errorMessage || 'Price not available';
          }
        });
      } else {
        const module = _module;
        const {
          productId,
          hasChildren,
          pricesExTax,
          resourceErrorMessage,
          initialized,
          originalPrice,
          isAuthenticated,
          salesPrice
        } = module.dataset;
        if (!productId && (initialized != null && initialized)) return;
        if (!parseInt(isAuthenticated, 10)) return;

        module.dataset.initialized = true; // skip initialized module items
        module.classList.add('is-loading');
        this.getPrice(productId)
          .then(response => {
            // eslint-disable-next-line no-underscore-dangle
            const { prices } = response._embedded;

            const templateView = 'RealTimePrice';
            const price = prices.length ? prices[0] : null;

            const viewData = {
              hasChildren,
              pricesExTax: pricesExTax && JSON.parse(pricesExTax.toLowerCase()),
              hasSale: false
            };
            if (!pricesExTax) {
              price.originalPriceInclVat = parseFloat(originalPrice);
            } else {
              price.originalPrice = parseFloat(originalPrice);
            }
            const salesPriceParsed = parseFloat(salesPrice) || 0;

            if (price !== null) {
              viewData.price = price;

              if (salesPriceParsed && price.currentPrice < salesPriceParsed) {
                viewData.hasSale = true;
                viewData.salePercentage = 100 - (price.currentPrice * 100) / salesPriceParsed;
                viewData.salesPrice = salesPriceParsed;
              }
            }

            // create view based on template file
            jsonToView(viewData, templateView)
              .then(html => {
                module.classList.remove('is-loading');
                module.innerHTML = html;
              })
              .catch(error => {
                module.classList.remove('is-loading');
                module.innerHTML = resourceErrorMessage || 'Price not available';
                throw new Error(error);
              });
          })
          .catch(error => {
            module.classList.remove('is-loading');
            module.innerHTML = resourceErrorMessage || 'Price not available';
            throw new Error(error);
          });
      }
    });
  }
}

export default RealTimePrice;
